// .b-faq__item-response {
//   overflow: hidden;
//   transition: max-height $transition-duration ease;
//   &[aria-hidden="true"] {
//     max-height: 0;
//   }
// }

// {% set random_id = random() %}
// <div class="b-faq__item">
//   <button class="b-faq__item-question js-accordion" id="faq-button-{{ random_id }}-{{ loop.index }}" aria-expanded="false" aria-controls="faq-panel-{{ random_id }}-{{ loop.index }}" data-panel="#faq-panel-{{ random_id }}-{{ loop.index }}">
//     {{ item.question }}
//   </button>

//   <div class="b-faq__item-response" id="faq-panel-{{ random_id }}-{{ loop.index }}" aria-hidden="true" aria-labelledby="faq-button-{{ random_id }}-{{ loop.index }}">
//     {{ item.response|raw }}
//   </div>
// </div>

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.js-accordion').forEach((accordion) => {
    accordion.addEventListener('click', (event) => {
      event.preventDefault();

      const panelElement = document.querySelector(accordion.dataset.panel);

      if (panelElement.getAttribute('aria-hidden') === 'true') {
        panelElement.style.maxHeight = panelElement.scrollHeight + 'px';
        panelElement.setAttribute('aria-hidden', 'false');
        accordion.setAttribute('aria-expanded', 'true');
      } else {
        panelElement.style.maxHeight = 0;
        panelElement.setAttribute('aria-hidden', 'true');
        accordion.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.querySelectorAll('.js-accordion-close').forEach((accordionClose) => {
    accordionClose.addEventListener('click', (event) => {
      event.preventDefault();

      const buttonElement = document.querySelector(accordionClose.dataset.button);
      buttonElement.click();
    });
  });

});
